export type OnboardingVariant = 'classic' | 'emotional';

const STORAGE_KEY = 'noma_v2_onboarding_variant';

export function getOnboardingVariant(): OnboardingVariant {
  try {
    const queryVariant = new URLSearchParams(window.location.search).get('onboarding_variant');
    if (queryVariant === 'classic' || queryVariant === 'emotional') {
      localStorage.setItem(STORAGE_KEY, queryVariant);
      return queryVariant;
    }
    const localVariant = localStorage.getItem(STORAGE_KEY);
    if (localVariant === 'classic' || localVariant === 'emotional') return localVariant;
  } catch { /* noop */ }

  const envVariant = String(import.meta.env.VITE_ONBOARDING_VARIANT || '').toLowerCase();
  return envVariant === 'classic' ? 'classic' : 'emotional';
}

export function setOnboardingVariant(variant: OnboardingVariant): void {
  try { localStorage.setItem(STORAGE_KEY, variant); } catch { /* noop */ }
}
